const PREMIUM_OFFERS_LOADING = "PREMIUM_OFFERS_LOADING";
const PREMIUM_OFFERS_ERROR = "PREMIUM_OFFERS_ERROR";
const PREMIUM_OFFERS_SUCCESS = "PREMIUM_OFFERS_SUCCESS";

export { PREMIUM_OFFERS_LOADING, PREMIUM_OFFERS_ERROR, PREMIUM_OFFERS_SUCCESS };